

function UserHistory() {

    /// <summary>
    /// This object provides client-side functions for the Widget.Membership.UserHistory visual. <br/>
   /// <br/>
    /// Author: AFU<br />
    /// Date: 7.06.2016<br />
    /// Copyright ©: EUDT GmbH 2016 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 7.06.2016                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
    this.validation = null;
}
UserHistory.prototype = new vcTemplate();
UserHistory.prototype.init = function () {
    /// <summary>
    /// This function inits the details clickhandler adds a style for the list entries.
    /// </summary>
    var me = this;
    try {
        if (me.error) {return false;}
      
        me.showInfo("", "", false);
        me.visual.find(".list").filter(":even").addClass("tblRowAlt");
        me.visual.find(".btn").button().on("click", function() {me.loadDetails($(this));});
        return true;
    } catch (ex) {
        me.writeError('init', ex);
        return false;
    }

};


UserHistory.prototype.loadDetails = function (obj) {
    /// <summary>
    /// Loads the entry details for the given login session<br/>
    /// </summary>
    var me = this;
    var id;
    try {
        if (me.error) {
            return false;
        }

        id = obj.data("id");
        window.VisualCoreService.getData(me.vcvid, me.vcgid, window.getCurrentTimestamp(), 0, 0, "", "", me.deviceType, me.langid, id, function (result) {
            if (result === null) {
                me.showMessage(me.resources.err_loadData, true);
                return false;
            }
            me.visual.find(".entries[data-id='" + id + "']").html(result).show();
            return true;
        });
        return true;
    } catch (ex) {
        me.writeError('loadDetails', ex);
        return false;
    }
};

UserHistory.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
        if (bError) {
            me.visual.find('.list').hide();
        }
        return true;
    } catch (ex) {
        me.writeError('specificInfoHandling', ex);
        return false;
    }
};



